import { render, staticRenderFns } from "./RsaPaiEditComponent.vue?vue&type=template&id=ec265a3e"
import script from "./RsaPaiEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPaiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports